import React from "react";
import { FormattedMessage } from "react-intl";
import PropTypes from "prop-types";
import { useApplicants, useShortlistApplicant, useToast } from "hooks";
import Modal, { MODAL_SIZE } from "components/Modal";
import { ProgressChecklist } from "components/Progress";
import { Spinner } from "components/Loader";

/**
 * ApplicantShortlistModal
 *
 * @param {String}    id
 * @param {Function}  onClose
 */
const ApplicantShortlistModal = ({ id, onClose, ...props }) => {
  const { toast } = useToast();
  const { data, loading, error } = useShortlistApplicant({ id });
  const { shortlistApplicant, shortlisting } = useApplicants({ skipQuery: true, enableCountQueries: false });

  const handleSubmit = () => {
    shortlistApplicant({
      variables: { input: { ids: [id] } },
      onCompleted: (data) => {
        const shortlisted = data?.shortlistMissionRoleApplicants?.shortlisted || [];
        const failedToShortlist = data?.shortlistMissionRoleApplicants?.failedToShortlist || [];

        onClose();

        if (shortlisted.length > 0) {
          toast.success(<FormattedMessage id="Missions.Applicants.ApplicantAdvancedOptions.SuccessShortlist" />);
        }

        if (failedToShortlist.length > 0) {
          toast.error(<FormattedMessage id="Missions.Applicants.ApplicantAdvancedOptions.Error" />);
        }
      },
      onError: () => {
        onClose();
        toast.error(<FormattedMessage id="Missions.Applicants.ApplicantAdvancedOptions.Error" />);
      },
    });
  };

  return (
    <Modal
      size={MODAL_SIZE.small}
      showSave={false}
      showSaveAsDestructable={true}
      primaryButtonMessageId="Proceed"
      secondaryButtonMessageId="Cancel"
      title={<FormattedMessage id="useApplicants.ShortListFromPendingModal.Title" />}
      canSubmit={true}
      loading={shortlisting}
      onClose={onClose}
      onSubmit={handleSubmit}
      {...props}
    >
      {loading ? (
        <Spinner />
      ) : (
        <>
          <ProgressChecklist
            error={error}
            steps={data?.checklist?.map((step) => ({
              name: step.name,
              title: (
                <div>
                  <FormattedMessage id={`Missions.Applicants.ApplicantProgress.Step.${step.name}`} />
                </div>
              ),
              isComplete: step.fulfilled,
            }))}
          />
        </>
      )}
    </Modal>
  );
};

ApplicantShortlistModal.propTypes = {
  id: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default ApplicantShortlistModal;
